<template>
  <div>
    <v-card flat>
      <v-row justify="center" class="pa-2 mx-2" v-if="bestBetProp.doc">
        <v-col cols="12" md="12" sm="12" class="mx-auto mb-5 text-center">
          <v-btn-toggle
              color="#73c603"
              v-model="toggle_exclusive"
              dense
              mandatory
          >
            <v-btn @change="handleClick('6107f818963dc87f216fa505')">
              Chazmule
            </v-btn>

            <v-btn @change="handleClick('60fedc56109bcffeb7010994')">
              doughboys123
            </v-btn>
          </v-btn-toggle>
        </v-col>

        <v-col>
          <v-col cols="12" md="10" sm="12" class="mx-auto">
            <v-sheet elevation="1" rounded="lg" class="pa-2">
              <v-card-title>
                <p class="text-h4 font-weight-medium" style="color: #ffd700">
                  GOLD
                </p>
              </v-card-title>
              <v-card-text style="line-height: 30px">
                <span v-html="bestBetProp.doc.gold"></span>
              </v-card-text>
            </v-sheet>
          </v-col>

          <v-col cols="12" md="10" sm="12" class="mx-auto">
            <v-sheet elevation="1" rounded="lg" class="pa-2">
              <v-card-title>
                <p class="text-h4 font-weight-medium" style="color: #c0c0c0">
                  SILVER
                </p>
              </v-card-title>

              <v-card-text style="line-height: 30px">
                <span v-html="bestBetProp.doc.silver" class="pa-2"></span>
              </v-card-text>
            </v-sheet>
          </v-col>

          <v-col cols="12" md="10" sm="12" class="mx-auto">
            <v-sheet elevation="1" rounded="lg" class="pa-2">
              <v-card-title>
                <p class="text-h4 font-weight-medium" style="color: #cd7f32">
                  BRONZE
                </p>
              </v-card-title>
              <v-card-text style="line-height: 30px">
                <span v-html="bestBetProp.doc.bronze" class="pa-2"></span>
              </v-card-text>
            </v-sheet>

            <!-- remark -->
            <v-sheet elevation="1" rounded="lg" class="my-3 pa-3">
              <div class="py-3">
                <b>REMARK:</b>&nbsp;
                <span v-html="bestBetProp.doc.remark"></span>
              </div>
            </v-sheet>
          </v-col>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "NflBestBetProps",

  data() {
    return {
      toggle_exclusive: 0,
    };
  },
  mounted() {
    this.handleClick('6107f818963dc87f216fa505')
  },

  computed: mapState("userModule", ["bestBetProp"]),

  methods: {
    handleClick(userId) {
      this.$store.dispatch("userModule/getBestBetProps", userId);
    },
  }
};
</script>

<style></style>
